import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { isArray } from 'lodash';
import { FilterKVP } from '../../interfaces/ProductFilter/FilterKVP';
import { getFilterKVPs } from '../../api/ProductFilter';

interface ProductFiltersDropdownProps {
  label?: string;
  filterValueIDs: number[];
  onChange: (ids: number[]) => void;
}

export const ProductFiltersDropdown = (props: ProductFiltersDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [kvps, setKVPs] = useState<FilterKVP[]>([]);

  useEffect(() => {
    setLoading(true);
    getFilterKVPs()
      .then((k) => setKVPs(k))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <FormControl size='small' fullWidth>
        {!!props.label && <InputLabel>{props.label}</InputLabel>}
        <Select
          multiple
          label={props.label}
          value={props.filterValueIDs}
          onChange={(e) =>
            props.onChange(isArray(e.target.value) ? e.target.value : [])
          }
        >
          {kvps.map((kvp) => (
            <MenuItem key={kvp.valueID} value={kvp.valueID}>
              {`${kvp.keyTitle} / ${kvp.valueTitle}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
